import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroApiPaths } from '../ApiPaths/KhodroApiPaths';
import { IPrintBimehNamehShakhsSalesByIdQuery } from '../SakhsSalesBimehNameh/Queries/IPrintBimehNamehShakhsSalesByIdQuery';
import { KhodroHttpGetService } from '../Services/KhodroHttpService';

const printBimehNamehShakhsSalesById = createAsyncThunk(
  'ShakhSalesBimehNamehPrint/printBimehNamehShakhsSalesById',
  async (query: IPrintBimehNamehShakhsSalesByIdQuery) => {
    return await KhodroHttpGetService({
      url: `${KhodroApiPaths.BimehNamehHayeShakhsSales.PrintBimehNamehShakhsSalesById}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);

export default printBimehNamehShakhsSalesById;
